import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AuthService } from '../../auth/components/services/auth.service';

@Injectable()
export class NetworkInterceptor implements HttpInterceptor {
    authService = inject(AuthService);
    requestCountSubject$ = this.authService.requestCountSubject$;
    private requestCount = 0;

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        this.requestCount++;
        this.requestCountSubject$.next(this.requestCountSubject$.getValue() + 1);
        return next.handle(request).pipe(
            finalize(() => {
                this.requestCount--;
                this.requestCountSubject$.next(this.requestCountSubject$.getValue() - 1);
                if (this.requestCount === 0 || this.requestCountSubject$.getValue() === 0) {
                    // Emit an event, call a function, or perform any other action when all requests are completed
                    this.authService.runApplicationLoader.next(false);
                }
            }),
        );
    }
}
